// extracted by mini-css-extract-plugin
var _1 = "SkGBvogNfCgRa5ApA8cg";
var _2 = "220px";
export { _1 as "container", _2 as "sidebarwidth" }
